import { createReducer } from "typesafe-actions";

import AccessChangeNotice from "@app/enum/AccessChangeNotice";
import { Actions as AppActions, reinitializeApp } from "@app/store/app/actions";

import {
  Actions,
  chooseAccessChangeOption,
  clearAccessChange,
  showAccessChangeNotice,
  showAccessChangePrompt,
} from "./actions";

export interface AccessChangeState {
  accessChangeNotice: AccessChangeNotice | undefined;
  accessChangePromptVisible: boolean;
  // Counts reinitializations. One changes the field models in place, so field lists built from them
  // rebuild when this changes.
  revision: number;
}

const initialState: AccessChangeState = {
  accessChangeNotice: undefined,
  accessChangePromptVisible: false,
  revision: 0,
};

const accessChange = createReducer<AccessChangeState, Actions | AppActions>(initialState)
  .handleAction(reinitializeApp.success, (state) => ({
    ...state,
    revision: state.revision + 1,
  }))
  .handleAction(showAccessChangePrompt, (state) => ({
    ...state,
    accessChangePromptVisible: true,
  }))
  .handleAction(chooseAccessChangeOption, (state) => ({
    ...state,
    accessChangePromptVisible: false,
  }))
  .handleAction(showAccessChangeNotice, (state, { payload }) => ({
    ...state,
    accessChangeNotice: payload,
  }))
  .handleAction(clearAccessChange, () => initialState);

export * from "./selectors";
export type AccessChangeActions = Actions;
export default accessChange;
